import { render } from "./ZombieDetailsModal.vue?vue&type=template&id=48391a6e&scoped=true"
import script from "./ZombieDetailsModal.vue?vue&type=script&lang=js"
export * from "./ZombieDetailsModal.vue?vue&type=script&lang=js"

import "./ZombieDetailsModal.vue?vue&type=style&index=0&id=48391a6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48391a6e"]])

export default __exports__